import React from "react"

import Variants from "./Variants"

const Component = ({ resource }) => {
  const onlyShowVariants = [...new Set(resource.variants)]

  return <Variants resource={resource} onlyShowVariants={onlyShowVariants} />
}

export default Component
